<template lang="html">

  <section class="wrapper home">

    <div class="encabezado" data="home"></div>

    <div class="content">

      <div class="claim-home">
        <h2>Conectando Talento y Oportunidades</h2>
        <h3>Portal de Empleo UVa</h3>
      </div>


      <section class="ofertas-wrapper container row-between ais">
        <ofertas></ofertas>
        <accesos></accesos>
      </section>



      <!-- <comunicaciones></comunicaciones> -->

      <section class="colaboradores container">

        <h1 class="underlined">Colaboradores</h1>

        <ul class="colaboradores-list row-center ais">

          <li>
            <img src="/static/img/logos/camara.png" alt="Camara">
          </li>
          <li>
            <img src="/static/img/logos/cepsa.png" alt="Cepsa">
          </li>
          <li>
            <img src="/static/img/logos/endesa.png" alt="Endesa">
          </li>
          <li>
            <img src="/static/img/logos/eptisa.png" alt="Eptisa">
          </li>
          <li>
            <img src="/static/img/logos/symbiosis.png" alt="Symbiosis">
          </li>
          <li>
            <img src="/static/img/logos/telefonica.png" alt="Teléfonica">
          </li>


        </ul>


        <router-link class="btn -skull" :to="$t('enlaces.colaboradores')">Ver más</router-link>

      </section>

    </div>


  </section>

</template>

<script lang="js">

  import comunicaciones from '@/components/view-parts/home/comunicaciones';
  import ofertas from '@/components/view-parts/home/ofertas';

  import programasactivos from '@/components/view-parts/home/programas-activos';

  import accesos from '@/components/parts/accesos';

  export default {
    name: 'home',
    components: {
      'comunicaciones': comunicaciones,
      'programasactivos': programasactivos,
      'ofertas': ofertas,
      'accesos': accesos
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/views/home.vue